import React, {useEffect, useState} from "react"
import {takePanelStore} from "../../../common/take-panel/TakePanelStore"
import {messageStore} from "../../../common/messages/MessageStore"
import {ApiItemResponse, ApiPanel, ItemFormatEnum, PanelLevel} from "../../../../types/types"
import {AvantCircularProgress, CircularProgressSize} from "../../../common/loaders/AvantCircularProgress"
import {Divider, List, ListItem} from "@material-ui/core"
import {theme} from "../../../../styles/MuiThemes"
import {ApiTakePanel} from "../../../common/take-panel/models/ApiTakePanel"
import {LinkText, SmallBodyText} from "../../../../styles/AvantTypography"

interface SidebarResponsesContainerProps {
    takePanelId: number,
    fullName: string,
}

const SidebarResponsesContainer = (props: SidebarResponsesContainerProps) => {
    const [detailedTakePanel, setDetailedTakePanel] = useState<ApiTakePanel>()
    const [responses, setResponses] = useState<ApiItemResponse[]>([])

    useEffect(() => {
        fetchDetailedTakePanel(props.takePanelId)
            .catch((err) => {
                messageStore.setErrorMessage(err)
            })

        async function fetchDetailedTakePanel(takePanelId: number) {
            const takePanel = await takePanelStore.getDetailedTakePanel(takePanelId)
            if (takePanel) {
                const responses = takePanel.responses.filter((response: ApiItemResponse) => {
                    return response.itemFormat !== ItemFormatEnum.BLANK &&
                        !response.itemName.toLowerCase().includes("sample") &&
                        !response.itemName.toLowerCase().includes("practice")
                }).sort((responseA, responseB) => responseA.id - responseB.id)

                setDetailedTakePanel(takePanel)
                setResponses(responses)
            }
        }
    }, [])

   if (!responses.length || detailedTakePanel === undefined) {
       return <AvantCircularProgress size={CircularProgressSize.SMALL} />
   }

    return (
        <List
            dense
            style={{padding: theme.spacing(3)}}
        >
            <Divider style={{marginBottom: theme.spacing(2)}}/>
            {responses.map((response: ApiItemResponse, idx: number) => {
                const score: string = detailedTakePanel.responseLevels ? detailedTakePanel.responseLevels[response.id] : ""
                const benchmark: string = detailedTakePanel.responseBenchmarks ? detailedTakePanel.responseBenchmarks[response.id] : ""

                let indicatorOrReason: string = ""

                if (detailedTakePanel.responseStrengthIndicators) {
                    indicatorOrReason = detailedTakePanel.responseStrengthIndicators[response.id]
                }
                if (score === PanelLevel.PANEL_NOT_RATABLE || score === PanelLevel.PANEL_LEVEL_0) {
                    indicatorOrReason = detailedTakePanel.responseReasonCodes ? detailedTakePanel.responseReasonCodes[response.id] : ""
                }

                return (
                    <SidebarResponse
                        key={response.id}
                        takePanelId={detailedTakePanel.id}
                        response={response}
                        responseNumber={idx+1}
                        fullName={props.fullName}
                        panel={detailedTakePanel.panel}
                        score={score}
                        indicatorOrReason={indicatorOrReason}
                        benchmark={benchmark}
                    />
                )
            })}
        </List>
    )
}

interface SidebarResponseProps {
    takePanelId: number,
    response: ApiItemResponse,
    responseNumber: number,
    fullName: string,
    panel: ApiPanel,
    score?: string,
    indicatorOrReason?: string,
    benchmark?: string,
}

// TODO: update this component to handle response modal
const SidebarResponse = (props: SidebarResponseProps) => {
    return (
        <ListItem disableGutters={true}>
            <LinkText
                disabled={true}
                style={{
                    paddingRight: theme.spacing(2),
                    color: "#585858",
                    whiteSpace: "nowrap",
                }}
            >
                Response {props.responseNumber}
            </LinkText>
            {props.score && <SmallBodyText>Score: {props.score} {props.indicatorOrReason} {props.benchmark}</SmallBodyText>}
        </ListItem>
    )
}

export default SidebarResponsesContainer
